import { fromZonedTime } from 'date-fns-tz';

import { parseDateValue } from './parseDateValue';

export const pickerDateToUtc = (pickerDate, tz) => {
  if (!pickerDate) return null;
  return fromZonedTime(pickerDate, tz).toISOString();
};

export const toDateOnlyString = (date) => {
  if (!date) return null;
  const m = String(date.getMonth() + 1).padStart(2, '0');
  const d = String(date.getDate()).padStart(2, '0');
  const y = date.getFullYear();
  return `${m}/${d}/${y}`;
};

export const displayValue = (value, timezone, isRangeValue) => {
  if (isRangeValue) {
    if (!value) return [null, null];
    const [startUtc, endUtc] = value;
    return [parseDateValue(startUtc, timezone), parseDateValue(endUtc, timezone)];
  }
  if (!value) return null;
  return parseDateValue(value, timezone);
};
